export const environment = {
  production: false,
  authMock: false,
  apiBaseUrl: '',
  msalConfig: {
    auth: {
      clientId: '8bc38f68-bfa1-4e89-afba-52f396f32fb6',
      authority: 'https://login.microsoftonline.com/b3e2a318-3f14-477a-8029-a60a9562673a',
      redirectUri: 'https://staging-erp.wntkft.hu',
    },
    scopes: ['api://8bc38f68-bfa1-4e89-afba-52f396f32fb6/access'],
  },
};
